export const DEFAULT_FILTERS = [
    {id: 'active', name: 'active', '@type': 'Status'},
    {id: 'valid', name: 'valid', '@type': 'Validated'},
    {id: 'yes', name: 'yes', '@type': 'OnEshop'},
    {id: 'instock', name: 'instock', '@type': 'Stock'},
];

export const isDefaultFilterSet = (filters) => filters.every((filter) => DEFAULT_FILTERS.some((defaultFilter) => defaultFilter.id === filter.id));

// The Status and Scoring tabs' groups are exclusive: selecting one option of
// the group replaces the other (never both "active" and "inactive" at once).
// The other types (Brand, Category, Retailer…) stay multi-select. The Price
// and Sales tabs' value filters are exclusive too, but go through filter_set
// (fixed id, the new value replaces the old instead of toggling it off).
const EXCLUSIVE_TYPES = ['Status', 'Validated', 'OnEshop', 'Stock', 'LimitedDistribution', 'PriceMin', 'PriceMax', 'DiscountMin', 'DiscountMax', 'SalesMin', 'Benchmark', 'Demand'];

export function filterReducer(filters, action) {

    function removeFromFilters(filters, item) {
        return filters.filter(function(filter) {
            return filter.id !== item.id;
        });
    }

    switch (action.type) {
        case 'filter': {
            let f = filters.find(f => f.id === action.item.id);
            if (f !== undefined) {
                return removeFromFilters(filters, action.item);
            }
            if (EXCLUSIVE_TYPES.includes(action.item['@type'])) {
                return [...filters.filter(f => f['@type'] !== action.item['@type']), action.item];
            }
            return [...filters, action.item];
        }
        case 'filter_set': {
            // set-or-replace by id: unlike 'filter', re-dispatching the same id
            // with a new value replaces it instead of toggling the filter off
            return [...removeFromFilters(filters, action.item), action.item];
        }
        case 'filter_remove': {
            return removeFromFilters(filters, action.item);
        }
        case 'filters_reset': {
            return [];
        }

        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}
